<div>
  <div class="row">
    <div class="col-md-12">
      <button class="btn btn-primary btn-sm"  style="margin-left: 10px; margin-top: 10px" (click)="printReceiptClick()">
        Print
      </button>
      <button
        type="button"
        class="btn-close float-end"
        data-bs-dismiss="modal"
        aria-label="Close"
        style="margin-right: 10px; margin-top: 10px"
        (click)="closeModalClick()"
      ></button>
    </div>
    <div class="card-print" id="receipt" #receipt>
      <div class="title-buffer"></div>
      <div class="card-header">
        <div class="row">
          <h4 style="text-align: center; font-weight: bold;">{{ receiptTitle }}</h4>
        </div>
        <div class="row">
          <div class="col-6">
            <p style="line-height: 1.25">
              <span style="font-weight: bold">{{sharedService.company_info.company_name}}</span
                ><br />
                @if (!company_street_address.includes('null')) {
                  <span>{{ company_street_address }}</span
                    >
                    }<br />
                    @if (!company_city_state_zip.includes('null')) {
                      <span>{{ company_city_state_zip }}</span
                        >
                        }<br />
                        @if (!sharedService.company_info.customer_facing_email.includes('null')) {
                          <span>
                            {{sharedService.company_info.phone_number}}
                            </span
                            >
                            }<br />
                            @if (!sharedService.company_info.customer_facing_email.includes('null')) {
                              <span>
                                {{sharedService.company_info.customer_facing_email}}
                                </span
                                >
                                }<br />
                                @if (!sharedService.company_info.website.includes('null')) {
                                  <span>{{
                                    sharedService.company_info.website
                                    }}</span
                                    >
                                    }<br />
                                  </p>
                                  <!-- <h4 style="text-align: right">Sales Receipt</h4> -->
                                  <p style="line-height: 1.25">
                                    <span style="font-weight: bold">Bill To: </span><br />
                                    <span>{{ customer_info.contact.display_name | capitalizeFirst }}</span
                                      ><br/>
                                      @if (!customer_street_address.includes('null')) {
                                        <span>{{ customer_street_address }}</span
                                          >
                                          }<br/>
                                          @if (!customer_city_state_zip.includes('null')) {
                                            <span>{{ customer_city_state_zip }}</span
                                              >
                                              }<br/>
                                            </p>
                                          </div>
                                          <div class="col-6">
                                            <div class="float-end">
                                              @if (sharedService.company_info.company_logo) {
                                                <div
                                                  class="image-container">
                                                  <img
                                                    [src]="sharedService.company_info.company_logo"
                                                    alt="Company Logo"
                                                    class="company-logo"
                                                    />
                                                  </div>
                                                }
                                              </div>
                                              <br />
                                              <br />
                                              <br />
                                              <br />
                                              <br />
                                              <br />
                                              <div style="text-align: end">
                                                <span style="font-weight: bold">Sales #</span>
                                                {{ sales_receipt.sales_receipt_number }}
                                              </div>
                                              <div style="text-align: end">
                                                <span style="font-weight: bold">Date</span>
                                                {{ sales_receipt.receipt_date | date : "longDate" }}
                                              </div>
                                              <!-- Add Logo and sales receipt number and date-->
                                            </div>
                                          </div>
                                        </div>
                                        <hr />
                                        <span style="font-weight: bold">Sales Rep: </span
                                          >{{ sales_receipt.sales_rep }}
                                          <hr />
                                          <div class="card-body">
                                            <table class="table">
                                              <thead>
                                                <tr>
                                                  <th>Service Date</th>
                                                  <th>Product / Service</th>
                                                  <th>Description</th>
                                                  <th>Quantity</th>
                                                  <th>Rate</th>
                                                  <th>Amount</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                @for (item of sales_receipt.sales_items; track item) {
                                                  <tr>
                                                    <td>{{ item.service_date }}</td>
                                                    <td>{{ item.product_service }}</td>
                                                    <td>
                                                      {{ item.description }} @if (item.firearm) {
                                                      <br />
                                                    }
                                                    @if (item.firearm) {
                                                      <span
                                                        >Serial#:{{ item.serial_number }}</span
                                                        >
                                                    }
                                                  </td>
                                                  <td style="text-align: center">{{ item.qty }}</td>
                                                  <td style="text-align: center">{{ (+item.rate).toFixed(2) }}</td>
                                                  <td style="text-align: center">{{ (+item.amount).toFixed(2) }}</td>
                                                </tr>
                                              }
                                            </tbody>
                                          </table>
                                          <hr />
                                          <div class="row">
                                            <div class="col-6">
                                              <br />
                                              <br />
                                              <span
                                                style="font-weight: bold; font-size: large; display: block; white-space: pre-line; word-break: break-word; max-width: 100ch;"
                                                >
                                                @for (line of (sales_receipt.message_on_receipt | wordWrap:50); track line) {
                                                  {{ line }}<br />
                                                }
                                              </span>
                                            </div>
                                            <div class="col-4" style="text-align: right">
                                              <span>Subtotal</span><br />
                                              <span>Tax ({{ sales_receipt.sales_tax_rate }})%</span><br />
                                              <span>Total</span><br />
                                              <span>Balance Due</span>
                                            </div>
                                            <div class="col-2" style="text-align: right">
                                              <div style="margin-right: 25px">
                                                <span>{{ sales_receipt.subtotal.toFixed(2) }}</span
                                                  ><br />
                                                  <span>{{
                                                    (sales_receipt.subtotal * sales_receipt.sales_tax_rate).toFixed(
                                                    2
                                                    )
                                                    }}</span
                                                    ><br />
                                                    <span>{{ sales_receipt.total.toFixed(2) }}</span
                                                      ><br />
                                                      <span>${{ sales_receipt.balance_due.toFixed(2) }}</span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <!-- Total etc here-->
                                              </div>
                                            </div>
                                          </div>
                                        </div>
